/* Strategy Page — ML Strategy Prediction Center
   Uses Phase 4.1 components */

import { renderRegimeCard } from '../components/RegimeCard';
import { renderStrategyDetail } from '../components/StrategyDetail';
import { renderFeatureImportance } from '../components/FeatureImportance';
import { renderPerformanceChart } from '../components/PerformanceChart';
import { renderKeyLevels } from '../components/KeyLevels';
import { renderPhase2StrategyEngine } from '../components/charts/Phase2StrategyEngine';
import { isFeatureEnabled } from '../services/runtime-config';

export function renderStrategy(): string {
  if (isFeatureEnabled('charts_v2_engine')) {
    return '<div id="strategy-v2-root"></div>';
  }

  return `
    <div class="grid-strategy">
      <div style="display: flex; flex-direction: column; gap: var(--space-6);">
        <div id="strat-regime"></div>
        <div id="strat-features"></div>
        <div id="strat-performance"></div>
      </div>
      <div style="display: flex; flex-direction: column; gap: var(--space-6);">
        <div id="strat-detail"></div>
        <div id="strat-levels"></div>
      </div>
    </div>
  `;
}

export function initStrategy(): void {
  if (isFeatureEnabled('charts_v2_engine')) {
    const root = document.getElementById('strategy-v2-root');
    if (root) renderPhase2StrategyEngine(root);
    return;
  }

  const el = (id: string) => document.getElementById(id);

  const regimeEl = el('strat-regime');
  if (regimeEl) renderRegimeCard(regimeEl);

  const featEl = el('strat-features');
  if (featEl) renderFeatureImportance(featEl);

  const perfEl = el('strat-performance');
  if (perfEl) renderPerformanceChart(perfEl);

  const detailEl = el('strat-detail');
  if (detailEl) renderStrategyDetail(detailEl);

  const levelsEl = el('strat-levels');
  if (levelsEl) renderKeyLevels(levelsEl);
}
